import { render, staticRenderFns } from "./CartaForm.vue?vue&type=template&id=c7bce032&scoped=true&"
import script from "./CartaForm.vue?vue&type=script&lang=js&"
export * from "./CartaForm.vue?vue&type=script&lang=js&"
import style0 from "./CartaForm.vue?vue&type=style&index=0&id=c7bce032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bce032",
  null
  
)

export default component.exports